import axios from 'axios';
import config from '../config';

const FLSApiClient = axios.create();

FLSApiClient.defaults.baseURL = config.FLS_API_DOMAIN;

export const setupAuth = (getToken: () => Promise<string>, logout: VoidFunction): void => {
  FLSApiClient.interceptors.request.use(
    async (requestConfig) => {
      const accessToken = await getToken();
      requestConfig.headers.Authorization = `Bearer ${accessToken}`;
      return requestConfig;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  FLSApiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response.status === 401) {
        const accessToken = await getToken();
        if (accessToken) {
          logout();
        }
      }
    }
  );
};

export default FLSApiClient;
